import Iconify, { type IconifyProps } from 'components/Iconify';

type Props = Omit<IconifyProps, 'icon'>;

export const MenuIcon = (props: Props) => {
  return <Iconify icon="eva:menu-2-fill" {...props} />;
};
